import styled from '@emotion/styled';
import { m } from 'framer-motion';
import { Button, StyledResetButton } from '~/shared/components';
import { StyledLine } from '~/shared/components/Line/styled';
import { breakpoints } from '~/theme';
import { pxToRem } from '~/theme';
import { ifProp, switchProp } from 'styled-tools';

export const StyledDynamicFilters = styled.div({
    height: 0,
    [`${StyledLine}`]: {
        display: 'none',
    },
    [breakpoints.md]: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        height: 'initial',
        overflow: 'visible',
        [`${StyledLine}`]: {
            display: 'block',
        },
    },
});

export const StyledFiltersPicker = styled.div({
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
});

export const StyledFiltersOptions = styled.div(({ theme }) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    height: theme.spaces[5],
}));

export const StyledOptionsButton = styled(StyledResetButton)(({ theme }) => ({
    fontSize: theme.fontSizes.sm,
    fontFamily: theme.fonts.body,
    padding: `0 ${theme.spaces[3]}`,
    display: 'none',
    '&:hover': {
        backgroundColor: theme.colors.light30,
    },
    svg: {
        fontSize: theme.fontSizes['md'],
        marginLeft: theme.spaces[2],
    },
    [breakpoints.md]: {
        display: 'flex',
    },
}));

export const StyledFilterList = styled.div(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    alignContent: 'flex-start',
    width: '100%',
    padding: `${theme.spaces[4]} 0 ${theme.spaces[4]} ${theme.spaces[4]}`,
}));

export const StyledChunkSizeFiltersWrapper = styled.div(({ theme }) => ({
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    gap: theme.spaces[3],
}));

export const StyledChunkSizeFilters = styled.div({
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
});

export const StyledFiltersWrapper = styled.div({
    flex: '1 1 100%',
    columnWidth: 200,
    columnCount: 'auto',
});
export const StyledResponsiveTriggers = styled.div<{ shouldShow?: boolean }>(
    ({ theme }) => ({
        display: 'flex',
        position: 'fixed',
        // If the header is sticky, we need to offset by its height. If not, we'll just stay where we are.
        top: theme.traits.headerIsSticky ? theme.sizes.TotalHeaderHeight : 0,
        margin: `0 calc(${theme.gridConfig.gutter} * -1)`,
        left: 0,
        right: 0,
        whiteSpace: 'nowrap',
        zIndex: theme.zIndices['drawer'],
        opacity: 0,
        transform: 'translateY(-100%)',
        transition: `all ${theme.animations.getDuration('fast02')}`,
        pointerEvents: 'none',
        [breakpoints.md]: {
            display: 'none',
        },
        [`${StyledResponsiveTriggersButton}`]: {
            pointerEvents: 'none',
        },
    }),
    ifProp('shouldShow', ({ theme }) => ({
        opacity: 1,
        pointerEvents: 'initial',
        transform: 'translateY(0)',
        transition: `all ${theme.animations.getDuration('fast02')}`,
        [`${StyledResponsiveTriggersButton}`]: {
            pointerEvents: 'initial',
        },
    }))
);

export const StyledResponsiveTriggersButton = styled(Button)(({ theme }) => ({
    fontSize: theme.fontSizes.sm,
    flex: '1 1 50%',
    textAlign: 'center',
    padding: `${pxToRem(12)} ${theme.spaces[4]}`,
    borderTop: `1px solid ${theme.traits.mobileFacetButtons.borderColor}`,
    borderBottom: `1px solid ${theme.traits.mobileFacetButtons.borderColor}`,
    backgroundColor: theme.colors.light,
    color: theme.traits.mobileFacetButtons.color,
    svg: {
        fontSize: theme.fontSizes.sm,
        marginRight: theme.spaces[1],
    },
    [`&:first-of-type`]: {
        borderRight: `1px solid ${theme.traits.mobileFacetButtons.borderColor}`,
    },
}));

export const StyledSelectedFiltersWrapper = styled.div({
    display: 'none',
    justifyContent: 'space-between',
    [breakpoints.md]: {
        display: 'flex',
    },
});

export const StyledAttributeGroups = styled.div({
    display: 'none',
    [breakpoints.md]: {
        display: 'flex',
    },
});

export const StyledOpenFilterContainer = styled(m.div)(({ theme }) => ({
    width: '100%',
    overflow: 'hidden',
    borderLeft: theme.traits.line.asBorderStyle,
    borderRight: theme.traits.line.asBorderStyle,
    display: 'none',
    [breakpoints.md]: {
        display: 'block',
    },
}));
export const StyledAttributes = styled.div(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    width: '100%',
    padding: theme.spaces[4],
}));

export const StyledAttribute = styled.div({
    width: '100%',
});

export const StyledResponsiveCount = styled.div<{ variant?: 'mobile' | 'desktop' }>(
    {
        flex: 1,
        textAlign: 'right',
    },
    switchProp('variant', {
        mobile: {
            [breakpoints.md]: {
                display: 'none',
            },
        },
        desktop: ({ theme }) => ({
            display: 'none',
            [breakpoints.md]: {
                display: 'block',
                margin: `${theme.spaces[2]} 0`,
            },
        }),
    })
);
